import { render, staticRenderFns } from "./password-reset-request.vue?vue&type=template&id=3b95382c&scoped=true"
import script from "./password-reset-request.vue?vue&type=script&lang=js"
export * from "./password-reset-request.vue?vue&type=script&lang=js"
import style0 from "./password-reset-request.vue?vue&type=style&index=0&id=3b95382c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b95382c",
  null
  
)

export default component.exports